import React from "react";
import extendedDayjs from "Helpers/dayjs";
import {BingoCountdownTypography} from "./BingoCountdownTypography";
import {BingoCountdownTimer} from "./BingoCountdownTimer";
import {ClockIcon} from "Components/CustomIcons";
import {Box, makeStyles, Tooltip, withStyles} from "@material-ui/core";
import clsx from "clsx";

const useCountdownStyles = makeStyles(theme => {
    const bingoCardsSettings = theme.overrides.BingoCards;

    return {
        root: {
            fontFamily: bingoCardsSettings.fontFamily,
        },
        timeContainer: {
            background: "#fff",
            borderRadius: 50,
            color: "black",
            padding: theme.spacing(0, 0.5),
            zIndex: 1,
            height: 25,
            minWidth: 64,
            '& > .MuiSvgIcon-root': {
                fontSize: theme.spacing(2.5),
            },
        },
        time: {
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
        },
    }
})

const hourInSeconds = (60 * 60);
const dayInSeconds = (hourInSeconds * 24);

const CustomToolTip = withStyles({
    tooltip: {
        margin: 2,
    }
})(Tooltip);

export const BingoCountdown = (props) => {
    const classes = useCountdownStyles();

    let renderedDate = false;
    try {
        if (props.seconds > dayInSeconds && props.date) {
            renderedDate = extendedDayjs.unix(props.date).format("DD MMM @ h:mmA");
        } else if (props.seconds < dayInSeconds && props.seconds > hourInSeconds && props.date) {
            renderedDate = "Today " + extendedDayjs.unix(props.date).format("@ h:mmA");
        }
    } catch (e) {
        console.log(e);
    }

    return (
        <>
            <CustomToolTip arrow title={"Next Game"}>
                <Box display="flex" alignItems="center" className={clsx(classes.timeContainer)} sx={props.styles}>
                    <ClockIcon/>
                    <Box className={classes.time}>
                        <Box px={0.5}>
                            {(renderedDate && props.seconds > hourInSeconds) ?
                                <BingoCountdownTypography mini>{renderedDate}</BingoCountdownTypography> :
                                <BingoCountdownTimer small seconds={props.seconds}/>
                            }
                        </Box>
                    </Box>
                </Box>
            </CustomToolTip>
        </>
    );
}
